import "bootstrap/js/dist/util"
import "bootstrap/js/dist/collapse"
import "bootstrap/js/dist/dropdown"
import "slick-carousel"
import "popper.js"
import "jquery-match-height"
import Vue from "vue"
import VeeValidate, { Validator } from "vee-validate"
import { debounce } from "lodash"
import Forms from "./components/forms"
import LeadForm from "./components/lead-form.vue"
import Scroller from "./components/scroller"

Validator.extend("tel", {
  getMessage: () =>
    `Please enter a valid phone number. It has to start with 0 or +44 and contain 9-10 numbers.`,
  validate: () => true
})

Validator.extend("postcode", {
  getMessage: () => `Please enter a valid postcode.`,
  validate: value =>
    new RegExp(
      "^(([Gg][Ii][Rr] 0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([A-Za-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9]?[A-Za-z]))))\\s?[0-9][A-Za-z]{2}))$"
    ).test(value.trim())
})

Vue.use(VeeValidate, { events: "blur" })
Vue.prototype.$themeUrl = window.App.themeUrl

class App {
  static init() {
    new Forms().init()
    new Scroller().watch()
    ;[...document.querySelectorAll("section.hero")].forEach(el => {
      // eslint-disable-next-line
      new Vue({
        el,
        components: { LeadForm }
      })
    })

    $("#topNav")
      .on("hide.bs.collapse", () => {
        $(".navbar").removeClass("active")
        $(".navbar")
          .find(".hamburger")
          .removeClass("is-active")
      })
      .on("show.bs.collapse", () => {
        $(".navbar").addClass("active")
        $(".navbar")
          .find(".hamburger")
          .addClass("is-active")
      })

    $("section.blog-carousel .slick-slider").slick({
      slidesToShow: 3,
      slidesToScroll: 3,
      arrows: true,
      infinite: false,
      dots: true,
      nextArrow:
        '<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="50" stroke-width="1.4" d="M1 8h14M8 1v0l7 7v0l-7 7v0"/></svg></button>',
      prevArrow:
        '<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="50" stroke-width="1.4" d="M15 8H1m7 7v0L1 8v0l7-7v0"/></svg></button>',
      appendArrows: $("section.blog-carousel .custom-navigation"),
      appendDots: $("section.blog-carousel .custom-navigation"),
      responsive: [
        {
          breakpoint: 768,
          settings: {
            centerPadding: "30px",
            dots: false,
            adaptiveHeight: true,
            centerMode: true,
            infinite: true,
            slidesToShow: 1
          }
        }
      ]
    })

    $("section.related-articles .slick-slider").slick({
      slidesToShow: 3,
      slidesToScroll: 3,
      arrows: false,
      dots: false,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            centerPadding: "30px",
            dots: false,
            adaptiveHeight: true,
            centerMode: true,
            infinite: true,
            slidesToShow: 1
          }
        }
      ]
    })

    $("section.featured-points .slick-slider").slick({
      slidesToShow: 4,
      arrows: false,
      dots: false,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            arrows: true,
            dots: true,
            centerPadding: "15%",
            centerMode: true,
            slidesToShow: 1
          }
        }
      ]
    })

    $("section.trustpilot .slick-slider").slick({
      dots: false,
      arrows: true,
      nextArrow:
        '<button type="button" class="slick-next btn btn-outline-primary"><span>Next</span><span class="svg-container"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><path fill="none" stroke="#0b4f6c" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="50" stroke-width="1.4" d="M1 8h14M8 1v0l7 7v0l-7 7v0"/></svg></span></button>',
      prevArrow:
        '<button type="button" class="slick-prev btn btn-outline-primary"><span class="svg-container"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><path fill="none" stroke="#0b4f6c" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="50" stroke-width="1.4" d="M15 8H1m7 7v0L1 8v0l7-7v0"/></svg></span><span>Previous</span></button>'
    })

    $("section.partners .slick-slider").slick({
      centerMode: true,
      slidesToShow: 7,
      centerPadding: "100px",
      autoplay: true,
      arrows: false,
      dots: false,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    })

    $(window).on(
      "scroll",
      debounce(() => {
        const $bar = $("section.sticky-bar")

        $bar.toggleClass(
          "hide",
          $(document).scrollTop() + $(window).height() >=
            $(document).height() - $(window).height() / 2
        )
      }, 100)
    )
  }
}

App.init()
